export const autoPassTabs = [
  { text: 'Active 🔥', component: null },
  { text: 'Inactive', component: null },
];
